import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../Components/CSS/FilterStyle.css";

class StudentFilter extends Component {
  render() {
    const { classes, data, handleSearch } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.title}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="studentName"
            type="text"
            label="Student Name"
            variant="outlined"
            margin="normal"
            placeholder="Search by student's name"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.studentName}
            onChange={handleSearch}
          />
          <TextField
            name="level"
            type="text"
            label="Level"
            variant="outlined"
            margin="normal"
            placeholder="Search by level"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.level}
            onChange={handleSearch}
          />
          <TextField
            name="section"
            type="text"
            label="Section"
            variant="outlined"
            margin="normal"
            placeholder="Search by section"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.section}
            onChange={handleSearch}
          />
          <TextField
            name="year"
            type="text"
            label="Batch Year"
            variant="outlined"
            margin="normal"
            placeholder="Search by batch year"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.year}
            onChange={handleSearch}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(StudentFilter);
